import { render, staticRenderFns } from "./Dokumentasi.vue?vue&type=template&id=7f2eeb63&"
import script from "./Dokumentasi.vue?vue&type=script&lang=js&"
export * from "./Dokumentasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports